import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { UserService } from 'app/auth/user.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LanguageService, TranslatedLanguage } from 'app/shared/services/language.service';
import { LanguageModalComponent } from 'app/public/language-modal/language-modal.component';
import { UserInfo } from 'app/auth/user';
import { InternationalizationService } from '../../../shared/services/internationalization.service';

@Component({
  selector: 'app-painel-header',
  templateUrl: './painel-header.component.html',
  styleUrls: ['./painel-header.component.scss']
})
export class PainelHeaderComponent implements OnInit {

  public loggedIn: boolean;
  public user: UserInfo;
  public languages: Array<TranslatedLanguage> = [];
  private dialogRef: MatDialogRef<any, any>;

  constructor(
    public auth: AuthService,
    private userService: UserService,
    public dialog: MatDialog,
    public language: LanguageService,
    private internationalizationService: InternationalizationService,
  ) {
  }

  ngOnInit() {
  }

  logoutUser() {
    this.userService.clearUserCache();
    this.loggedIn = false;
    this.user = new UserInfo;
    this.auth.logout();
  }

  public changeLanguage(i: number, flag: string): void {
    const current = this.language.current();
    if (current.flag === flag) return;
    this.language.change(this.languages[ i ]);
    this.internationalizationService.changeLanguage(this.languages[ i ]);

    this.loadLanguage(i);
  }

  loadLanguage(i?: number): void {
    this.internationalizationService.getLanguages().then((data: TranslatedLanguage[]) => {

      if (data[ 'count' ]) {
        this.languages = data[ 'items' ];
        if (i != null) {
          this.language.saveCookie(this.languages[ i ]);
          this.language.change(this.languages[ i ]);
          // window.location.reload();
        }
      }
    });
  }

  openLanguageModal(): void {
    if (this.dialogRef == undefined) {
      this.dialogRef = this.dialog.open(LanguageModalComponent, {});

      this.dialogRef.afterClosed().subscribe(result => {
        this.dialogRef = result;
      });
    } else {
      this.dialog.closeAll();
      this.dialogRef = undefined;
    }
  }

}
